export const KeyCodes = { Ho: 32, Wo: 9, Go: 13, Ih: 27 };
